import { NgModule } from '@angular/core';
import { LogoComponent } from './logo.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CityByIdPipe } from './city-by-id.pipe';
import { OverlayComponent } from './overlay.component';
import { TranslateModule } from '@ngx-translate/core';

const declarations = [LogoComponent, OverlayComponent, CityByIdPipe];

const modules = [CommonModule, ReactiveFormsModule, FormsModule];

@NgModule({
  imports: [...modules, TranslateModule.forChild()],
  declarations: declarations,
  exports: [...declarations, ...modules],
})
export class GirkoCommonModule {}
